<template>
  <svg id="Сгруппировать_4773" data-name="Сгруппировать 4773" xmlns="http://www.w3.org/2000/svg" width="22.657" height="22.657" viewBox="0 0 22.657 22.657">
    <path id="Контур_4056" data-name="Контур 4056" d="M181.431-1070.915a11.329,11.329,0,0,0-11.329,11.329,11.329,11.329,0,0,0,11.329,11.329,11.328,11.328,0,0,0,11.329-11.329A11.328,11.328,0,0,0,181.431-1070.915Zm4.181,7.556a1.623,1.623,0,0,1,1.623,1.623,1.624,1.624,0,0,1-1.623,1.623,1.623,1.623,0,0,1-1.623-1.623A1.623,1.623,0,0,1,185.611-1063.359Zm-8.362,0a1.623,1.623,0,0,1,1.623,1.623,1.623,1.623,0,0,1-1.623,1.623,1.623,1.623,0,0,1-1.623-1.623A1.624,1.624,0,0,1,177.249-1063.359Zm-1.931,9.373a7.425,7.425,0,0,1,6.113-3.218,7.419,7.419,0,0,1,6.112,3.218.992.992,0,0,1-.255,1.38.991.991,0,0,1-1.38-.255,5.436,5.436,0,0,0-4.478-2.358,5.442,5.442,0,0,0-4.479,2.358.993.993,0,0,1-1.38.255A.994.994,0,0,1,175.318-1053.986Z" transform="translate(-170.102 1070.915)" fill="#e1cd9d"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconSad',
  }
</script>
